export default __webpack_public_path__ + "static/media/postman.73784122.png";